module.exports = __webpack_public_path__ + "img/logo.ee1f797.svg?v=1764327952164";